
import { useParams, Link } from "@/lib/router-compat";
import { BlogLayout } from "@/components/layout/BlogLayout";
import { LocalSEO2025Post } from "@/components/blog/posts/LocalSEO2025Post";
import { EcommerceCategoriesPost } from "@/components/blog/posts/EcommerceCategoriesPost";
import { SeoInteligentePost } from "@/components/blog/posts/SeoInteligentePost";
import { SeoReactPost } from "@/components/blog/posts/SeoReactPost";
import { NegocioIaPost } from "@/components/blog/posts/NegocioIaPost";
import { MarketingDigitalPymesPost } from "@/components/blog/posts/MarketingDigitalPymesPost";
import { VibeCodingPost } from "@/components/blog/posts/VibeCodingPost";
import { AiOverviewsSeoPost } from "@/components/blog/posts/AiOverviewsSeoPost";
import { TendenciasSeo2026Post } from "@/components/blog/posts/TendenciasSeo2026Post";
import { NovedadesIaMayo2026Post } from "@/components/blog/posts/NovedadesIaMayo2026Post";
import { GeoPracticeGuide } from "@/components/blog/GeoPracticeGuide";
import { geoGuides } from "@/data/geo-guides";

const BlogPost = () => {
  const { slug } = useParams<{ slug: string }>();
  if (geoGuides.some(guide => guide.slug === slug)) return <GeoPracticeGuide slug={slug} />;
  
  if (slug === "futuro-seo-local-2025") {
    return <LocalSEO2025Post />;
  }
  
  if (slug === "categorias-fichas-producto-ecommerce") {
    return <EcommerceCategoriesPost />;
  }

  if (slug === "seo-inteligente-ia") {
    return <SeoInteligentePost />;
  }

  if (slug === "seo-react-claves-optimizacion") {
    return <SeoReactPost />;
  }
  
  if (slug === "inteligencia-artificial-negocios") {
    return <NegocioIaPost />;
  }

  if (slug === "marketing-digital-pequenas-empresas") {
    return <MarketingDigitalPymesPost />;
  }

  if (slug === "vibe-coding-2026") {
    return <VibeCodingPost />;
  }

  if (slug === "google-ai-overviews-seo-2026") {
    return <AiOverviewsSeoPost />;
  }

  if (slug === "tendencias-seo-2026") {
    return <TendenciasSeo2026Post />;
  }

  if (slug === "novedades-ia-mayo-2026") {
    return <NovedadesIaMayo2026Post />;
  }
  
  return (
    <BlogLayout>
      <div className="flex flex-col items-center justify-center py-16">
        <h1 className="text-4xl font-bold mb-4">Blog no encontrado</h1>
        <p className="mb-8">Lo sentimos, el artículo que buscas no existe.</p>
        <Link to="/blog" className="bg-seo-blue px-6 py-3 rounded-md text-white hover:bg-seo-blue/80 transition-colors">
          Volver al blog
        </Link>
      </div>
    </BlogLayout>
  );
};

export default BlogPost;
